import(/* webpackMode: "eager", webpackExports: ["Navigation"] */ "/vercel/path0/app/components/portfolio/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButton"] */ "/vercel/path0/app/components/portfolio/ShareButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.9_@babel+core@7.28.6_@opentelemetry+api@1.9.0_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/og.png");
